import React from 'react';
import TransactionRatingTable from './TransactionRatingTable';
import RatingSummary from './RatingSummary';

function TransactionRatingPage() {
  return (
    <section>
      <RatingSummary />
      <TransactionRatingTable />
    </section>
  );
}

export default TransactionRatingPage;
